<script setup>
	import { DateTime } from "luxon";
	import { renderRichText2 } from '~/utils/richtext'

	const props = defineProps({ blok: Object, story: Object, author: Object, reviewer: Object, categories: Object })
	const b = props.blok

	const copy = computed(() => renderRichText2(b.copy))
	const i18n = useI18n()
	//const localePath = useLocalePath()

	//console.log('Story::', props.story)
	//console.log('copy 1::', b.copy)

	const dt = DateTime.fromISO((props.story).published_at)
	console.log('published_at::', (props.story).published_at)
	const date = ref(dt.toRelative())
	const year = new Date().getFullYear()
	const lang = i18n.locale.value

	const langPath = lang === 'en' ? '' : '/'+lang
	console.log('props.categories::', props.categories)

	//const category =  (props.categories as Array<any>)[0]
	//const translated = lang === 'en' || !category ? undefined : category.translated_slugs.filter((x:any)=>x.lang === lang)[0]
	//const categorySlug = translated?.path ? translated.path.split('/')[1] : category.slug
	//const categoryName = translated?.name ?? category.name
</script>

<template>

<!-- 
<div class="flex flex-row max-w-screen-md px-6 pb-2 mx-auto text-white text-xs" :class="{'max-w-screen-lg': b.portrait}">
	<NuxtLink class="text-white/50 hover:text-primary-100" :to="localePath('blog')">Blog</NuxtLink>
	<p class="px-2 text-white/10">></p>
	<NuxtLink class="text-white/50 hover:text-primary-100" :to="localePath('blog')+'?category='+categorySlug">{{ categoryName }}</NuxtLink>
	<p class="px-2 text-white/10">></p>
	<p class="text-white/30">{{ b.title }}</p>
</div> -->

<div class="mx-auto max-w-screen-md px-6 pt-4 text-white" :class="{'flex flex-col md:flex-row gap-x-10 max-w-screen-lg md:items-center': b.portrait}">


	<figure v-if="b.image?.filename" class="w-full" :class="{'aspect-video': !b.portrait, 'max-w-md': b.portrait}">
		<!-- do not lazy laod images above the fold -->
		<img class="rounded-3xl bg-newdark-750"  
		:width="imageDimension(b.image.filename).width"
		:height="imageDimension(b.image.filename).height"
		:alt="b.image.alt" :src="b.image.filename+'/m/'"  />
		<footer><small class="text-[.6rem] text-white/10">&#169; 2022-{{ year }} by {{ b.image.copyright }}</small></footer>
	</figure>

	<div class="">
		<div class="flex flex-row md:pt-10 justify-center items-center">
			<!-- <p v-for="item in categories" class="text-sm px-4 py-2 bg-orange-400 rounded-full">{{ item.name }}</p> -->
			<PostCategories :blok="categories"/>
			<p class="text-sm ml-auto pr-4 text-white/50">{{ date }}</p> 
		</div>
		<h1 class="text-4xl md:text-6xl pt-6 md:pr-10">{{ b.title }}</h1>
		<div v-if="copy" class="text-3xl font-thin pt-10" v-html="copy"></div>
		<!-- <Vue3RuntimeTemplate v-if="copy" class="text-3xl font-thin pt-10" :template="copy"></Vue3RuntimeTemplate> -->
			<!-- Author / Reviews -->
		<div class="flex flex-row gap-12 pt-10 ">
			<StoryblokComponent v-if="props.author" :blok="(author).content" />
			<StoryblokComponent v-if="props.reviewer" :blok="(reviewer).content" :reviewer="true" />
		</div>
	</div>
</div>

  <!-- <div v-editable="blok" class="px-4 pt-4 pb-10 mx-auto max-w-screen-md text-white">
		<div class="flex flex-row gap-12 pt-10 ">
			<StoryblokComponent v-if="props.author" :blok="author.content" />
			<StoryblokComponent v-if="props.reviewer" :blok="reviewer.content" :reviewer="true" />
		</div>

	
  </div> -->

	<!-- Content -->
	<div v-editable="b.content" class="text-white mx-auto w-full px-10 max-w-screen-lg">
		<StoryblokComponent v-for="content in b.content" :key="b._uid" :blok="content" />
	</div>

	<Share />

	<div v-if="b.references?.length || story?.tag_list?.length" class="grid md:grid-cols-6 gap-20 md:pt-20 text-white mx-auto w-full px-6 md:px-10 max-w-screen-xl pb-32">
			
			<div v-if="b.references?.length" class="col-span-6 md:col-span-3 max-w-max" >
				<h3 class="text-3xl font-bold pb-6">References</h3>
				<StoryblokComponent v-for="item in b.references" :blok="item" />
			</div>

			<div v-if="story?.tag_list?.length" class="col-span-6 md:col-span-3">
				<h3 class="text-xl font-bold pb-10 pt-2 text-white/50">Tags</h3>
				<div class="flex flex-wrap gap-3  max-w-xs md:max-w-screen-md lg:max-w-screen-lg">
					<NuxtLink 
						v-for="item in story.tag_list"
						:to="langPath+'/search?tag='+item"
						rel="nofollow"
						class="tag"
						>{{ item }}</NuxtLink>
				</div>
			</div>
		</div>
</template>
